import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AdditionalCharge } from 'services/checkout-service/models';
import { fromCentsWithLocale } from 'utils/Currency';
import { getAmountAndRateFromAdditionalCharges } from 'utils/Surcharges';
import { useCheckoutCurrency } from 'hooks/context/checkoutSession';

import { CONFIRMATION_TEST_IDS } from '../const';
import styles from './styles.module.scss';

type ConfirmationTotalProps = {
  amount: number;
  additionalCharges?: AdditionalCharge[];
  tipAmount?: number;
  taxAmount?: number;
}
export const ConfirmationTotals: FC<ConfirmationTotalProps> = props => {
  const { t } = useTranslation();
  const currency = useCheckoutCurrency();

  const {
    amount,
    additionalCharges = [],
    tipAmount = 0,
    taxAmount = 0
  } = props;

  const {
    amount: surchargeAmount,
    rate: surchargeRate,
    chargeType
  } = getAmountAndRateFromAdditionalCharges(additionalCharges) || {};

  const totalAmount = amount + (surchargeAmount ?? 0) + tipAmount + taxAmount;

  return (
    <div className={styles.totals}>
      {!!amount && totalAmount !== amount &&
        <>
          <h2 className="h6">{t('subtotal')}</h2>
          {/* TODO: use currency as per server */}
          <p data-testid={CONFIRMATION_TEST_IDS.subtotal}>{t('money', { amount: fromCentsWithLocale(amount, currency) })}</p>
        </>
      }
      {!!taxAmount &&
        <>
          <h2 className="h6">{t('tax')}</h2>
          <p data-testid={CONFIRMATION_TEST_IDS.taxAmount}>{t('money', { amount: fromCentsWithLocale(taxAmount, currency) })}</p>
        </>
      }
      {!!tipAmount &&
        <>
          <h2 className="h6">{t('tip')}</h2>
          <p data-testid={CONFIRMATION_TEST_IDS.tip}>{t('money', { amount: fromCentsWithLocale(tipAmount, currency) })}</p>
        </>
      }
      {surchargeAmount &&
        <>
          <h2 className="h6">
            {chargeType === 'CREDIT_SURCHARGE'
              ? t('surchargePercentage', { rate: surchargeRate })
              : t('convenienceFee')
            }
          </h2>
          {/* TODO: use currency as per server */}
          <p data-testid={CONFIRMATION_TEST_IDS.surcharge}>{t('money', { amount: fromCentsWithLocale(surchargeAmount, currency) })}</p>
        </>
      }

      <h2 className="h6">{t('total')}</h2>
      {/* TODO: use currency as per server */}
      <p data-testid={CONFIRMATION_TEST_IDS.total}>{t('money', { amount: fromCentsWithLocale(totalAmount, currency) })}</p>
    </div>
  );
};
